import React from "react";
import {StyledAddAddressModal} from "./AddAddressModal.styles";
import GoogleMap from "../GoogleMap";
const AddressModal = ({inputValue, setInputValue, closeModal, handlePlaceSelect}) => {
    return (
        <StyledAddAddressModal>
            <div className="map-holder">
                <GoogleMap
                    zoom={20}
                    showAddress
                    setInputValue={setInputValue}
                    closeModal={closeModal}
                    inputValue={inputValue}
                    handlePlace={handlePlaceSelect}
                />
            </div>
        </StyledAddAddressModal>
    );
};

export default AddressModal;
